<template>
  <div class="cam-support-overview">
    <div class="level no-margin">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item-horizontal">
          <ul class="context-options-right" v-if="isEditAllowed">
            <li><a @click.prevent="addNewCAM">Add new</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="enable-select-text">
      <circul8-table
        :records="data"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="false"
        :maxTextLength="'200'"
        :isLoading="isLoading"
        :showEditButton="isEditAllowed"
        :backendSortingEnabled="true"
        :routeNext="false"
        :showRemoveButton="isEditAllowed"
        @clickEdit="clickEdit"
        @clickView="clickView"
        @clickDelete="deleteModal"
        @backendSort="sortData"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        :allCountries="countries"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + data.length
                : totalRecords
              : data.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </div>

    <CountryAssignment
      :isActive="isModalActive"
      @cancle="modalClose"
      @submit="valueUpdated"
      :editData="editObject"
      :countries="countries"
      :users="users"
      :containers="containers"
      :isEdit="isEdit"
      :action="action"
      :isView="isView"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CountrySupportOverViewDataService from "../../services/CountrySupportOverViewDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import CountryAssignment from "@/components/Reportingtracker/CountrySupportAssignment.vue";
import { UserGroup } from "@/services/UserGroups";
import * as dayjs from "dayjs";
// @group Reporting Tracker
export default {
  mixins: [UtilityMixin, ScopeMixin],
  name: "CAMSupportOverviewChild",
  components: {
    Circul8Table,
    CountryAssignment
  },
  data() {
    return {
      isModalActive: false,
      editObject: this.getClearFormObject(),
      data: [],
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      columns: [
        {
          field: "code",
          label: "Flag",
          countryFlag: true,
          width: 60,
          searchable: false,
          filterKey: { code: "" },
          sortable: 1
        },
        {
          field: "country_id",
          label: "Country Name",
          searchable: true,
          visible: true,
          searchKey: "country_id",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countryNames,
          filterKey: { country_id: [] }
        },
        {
          field: "reporting_responsible_id",
          label: "Reporting Responsible",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: [],
          filterKey: { reporting_responsible_id: [] }
        },
        {
          field: "streams",
          label: "Stream",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.containers,
          filterKey: { streams: [] }
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          width: "20",
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      preData: [],
      isEdit: false,
      isView: false,
      isAdd: false,
      action: "Add",
      customerMap: {},
      query: "",
      countrySupportOverViewDataService: new CountrySupportOverViewDataService()
    };
  },
  computed: {
    ...mapGetters(["userGroups"]),
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.checkExternalPermission();
    this.fetchCustomerProfileData();
    this.fetchCountries();
    this.fetchContainers();
    this.fetchUserData();
  },
  watch: {
    users(newValue) {
      this.assignUserDropdown(newValue);
      this.fetchCountryList();
    },
    countries(newValue) {
      this.assignCountryDropdown(newValue);
    },

    containers(newValue) {
      this.assignStreamDropdown(newValue);
    }
  },
  methods: {
    deleteModal(editObject) {
      this.$buefy.dialog.confirm({
        title: "Deleting Country Assignment",
        message:
          "Are you sure you want to <b>delete</b> this Country Assignment?",
        confirmText: "Delete Country Assignment",
        hasIcon: true,
        onConfirm: () => this.deleteCAM(editObject)
      });
    },
    deleteCAM(editObject) {
      this.countrySupportOverViewDataService
        .delete(editObject)
        .subscribe(() => {
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Successfully Deleted!"
          });
          this.fetchCountryList(this.query);
        }, this.handleApiError);
    },
    clickEdit(editObject) {
      this.isEdit = true;
      this.action = "Update";
      const editData = this.preData.filter(i => i.id == editObject.id);
      this.editObject = editData ? editData[0] : [];
      this.isModalActive = true;
    },
    clickView(editObject) {
      this.isView = true;
      this.action = "View";
      const editData = this.preData.filter(i => i.id == editObject.id);
      this.editObject = editData ? editData[0] : [];
      this.isModalActive = true;
    },
    valueUpdated(editObject) {
      if (this.isAdd) {
        this.countrySupportOverViewDataService
          .create(editObject)
          .subscribe(() => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Country Assignment added Successfully!"
            });
            this.isModalActive = false;
            this.fetchCountryList(this.query);
          }, this.handleUpdateApiError);
      }
      if (this.isEdit) {
        this.countrySupportOverViewDataService
          .update(editObject)
          .subscribe(() => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Updated Successfully!"
            });
            this.isModalActive = false;
            this.fetchCountryList(this.query);
          }, this.handleApiError);
      }
    },
    modalClose() {
      this.isEdit = false;
      this.isView = false;
      this.isAdd = false;
      this.action = "Add";
      this.isModalActive = false;
      this.editObject = this.getClearFormObject();
    },
    addNewCAM() {
      this.isAdd = true;
      this.isModalActive = true;
      this.editObject = this.getClearFormObject();
    },
    getClearFormObject() {
      return {
        id: null,
        country_id: null,
        streams: [],
        reporting_responsible_id: null
      };
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["country_id"] = this.countryMap[reportData["country_id"]];
        reportData["reporting_responsible_id"] = this.userMap[
          reportData["reporting_responsible_id"]
        ];

        const stream_names = [];

        const streams = reportData["streams"];
        if (streams && streams.length > 0) {
          streams.forEach(element => {
            this.containerMap[element]
              ? stream_names.push(this.containerMap[element])
              : "";
          });
          stream_names.length > 0
            ? (reportData["streams"] = stream_names.join(", "))
            : "";
        }

        reportData["actions"] = this.isEditAllowed;
        reportData["delete"] = this.isEditAllowed;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.data.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = dataList;
      }
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchCountryList(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchCountryList(this.query, "prev");
    },
    searchByFilter(filterQuery) {
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchCountryList(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchCountryList(this.query);
    },
    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },

    assignStreamDropdown(streams) {
      const streamIndex = this.find_column_index("streams");
      this.columns[streamIndex].allStatusVals = streams;
    },
    assignUserDropdown(users) {
      const rr = this.filterUsers(users, UserGroup.REPORTING_RESPONSIBLE);
      const camIndex = this.find_column_index("reporting_responsible_id");
      this.columns[camIndex].allStatusVals = rr;
      for (const report in this.data) {
        const reportData = this.data[report];
        if (this.userMap[reportData["reporting_responsible_id"]]) {
          reportData["reporting_responsible_id"] = this.userMap[
            reportData["reporting_responsible_id"]
          ];
        }
      }
    },
    assignCountryDropdown(countries) {
      const countryIndex = this.find_column_index("country_id");
      this.columns[countryIndex].allStatusVals = countries;
      for (const report in this.data) {
        const reportData = this.data[report];
        reportData["country_id"] = this.countryMap[reportData["country_id"]];
        reportData["streams"] = this.countryMap[reportData["streams"]];
      }
    },
    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    fetchCountryList(query = "", scrollDir) {
      this.isLoading = true;
      this.data = [];
      this.countrySupportOverViewDataService
        .getCountryListData(query)
        .subscribe(
          response => {
            this.PreviousPageCursor = this.nextPageCursor
              ? this.nextPageCursor
              : this.PreviousPageCursor;
            this.nextPageCursor = response["next"];
            if (this.currentPage > 1) {
              this.previousData = true;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            } else {
              this.enableLoadMore = this.previousData = false;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            }
            this.totalRecords = response["count"];

            let tempData = [];
            if (scrollDir == "next") {
              if (!this.nextPageCursor) {
                this.preData = JSON.parse(JSON.stringify(response.results));
                this.prepareData(response["results"]);
              } else {
                //this.totalRecords = this.data.length + response["count"];
                tempData = [...this.data, ...response["results"]];
                if (tempData.length > 100 && this.nextPageCursor != null) {
                  tempData = tempData.slice(50, 150);
                }
                this.preData = JSON.parse(JSON.stringify(tempData));
                this.prepareData(tempData);
              }
            } else if (scrollDir == "prev") {
              if (this.currentPage == 0) {
                this.preData = JSON.parse(JSON.stringify(response.results));
                this.prepareData(response["results"]);
              } else {
                tempData = [...response["results"], ...this.data];
                if (tempData.length >= 100) {
                  tempData = tempData.slice(0, 100);
                }
                this.preData = JSON.parse(JSON.stringify(tempData));
                this.prepareData(tempData);
              }
            } else {
              this.preData = JSON.parse(JSON.stringify(response.results));
              this.prepareData(response["results"]);
            }
            this.isLoading = false;
          },
          e => {
            this.isLoading = false;
            this.nextData = false;
          }
        );
    },
    handleUpdateApiError(reason) {
      let errorMessage = reason.response.data["error"];
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        }
      }
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.isLoading = false;
    },
    handleApiError(reason) {
      let errorMessage = reason.response.data["error"];
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.fetchCountryList();
      this.isModalActive = false;
      this.isLoading = false;
    }
  }
};
</script>
